<template>
    <div style="padding: 20px">
<!--        中国地图-->
        <div class="china" ref="china"></div>
<!--        <div class="imgBox">-->
<!--            <img src="../../../assets/img/1.png" alt="" style="width: 75%">-->
<!--        </div>-->
    </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    name:'nationalNum',
    props:['allData'],
    data(){
        return{
            list:[
            ],
             chinaGeoCoordMap : {
                新疆: [86.9023, 41.148],
                西藏: [87.8695, 31.6846],
                内蒙古: [110.5977, 41.3408],
                青海: [95.2402, 35.4199],
                四川: [102.9199, 30.1904],
                黑龙江: [128.1445, 46.7156],
                甘肃: [102.7129, 38.166],
                云南: [101.0652, 24.6807],
                广西: [108.7813, 23.6426],
                湖南: [111.5332, 27.3779],
                陕西: [108.5996, 33.7396],
                广东: [113.8668, 22.8076],
                吉林: [126.1746, 43.5938],
                河北: [115.4004, 38.1688],
                湖北: [112.2363, 30.8572],
                贵州: [106.6113, 26.6385],
                山东: [118.2402, 36.2307],
                江西: [115.7156, 27.99],
                河南: [113.0668, 33.8818],
                辽宁: [123.0438, 41.0889],
                山西: [112.4121, 36.6611],
                安徽: [117.2461, 31.0361],
                福建: [118.3008, 25.9277],
                浙江: [120.498, 29.0918],
                江苏: [119.8586, 32.915],
                重庆: [107.7539, 29.8904],
                宁夏: [105.9961, 37.1096],
                海南: [109.9512, 19.2041],
                台湾: [120.8254, 23.5986],
                北京: [116.4551, 40.2539],
                天津: [117.4219, 39.4189],
                上海: [121.4648, 31.2891],
                香港: [114.6178, 22.3242],
                澳门: [113.5547, 21.6484],
            }
        }
    },
    methods:{
        chainaMap(){
            let myChart = echarts.init(this.$refs.china)
            let option;
            // 修改后的effectScatter数据格式
            const effectScatterData = this.list.map(item  => ({
                name: item.name,
                // 坐标数据保持独立
                value: this.chinaGeoCoordMap[item.name],
                // 新增自定义字段保存实际数值
                dataValue: item.value,
                contract_total_num:item.contract_total_num,
                tiaojie_total_num:item.tiaojie_total_num,
            }));
            option = {
                tooltip: {
                    trigger: 'item'
                },
                title: {
                    top: 50,
                    text: '全国业务数据',
                    subtext: '',
                    x: '10%',
                    textStyle: {
                        fontSize: 26,
                        color: '#acd3ec',
                    },
                },
                geo: {
                    map: 'china',
                    aspectScale: 0.75, //长宽比
                    zoom: 1.1,
                    scaleLimit : {
                        min:1,
                        max:3,
                    },
                    roam: false,
                    itemStyle: {
                        normal: {
                            areaColor: {
                                type: 'radial',
                                x: 0.5,
                                y: 0.5,
                                r: 0.8,
                                colorStops: [{
                                    offset: 0,
                                    color: '#09132c' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#274d68' // 100% 处的颜色
                                }],
                                globalCoord: true // 缺省为 false
                            },
                            shadowColor: 'rgb(58,115,192)',
                            shadowOffsetX: 10,
                            shadowOffsetY: 11
                        },
                        emphasis: {
                            areaColor: '#2AB8FF',
                            borderWidth: 0,
                            color: 'green',
                            label: {
                                show: false
                            }
                        }
                    },
                    regions: [{
                        name: '南海诸岛',
                        itemStyle: {
                            areaColor: 'rgba(0, 10, 52, 1)',

                            borderColor: 'rgba(0, 10, 52, 1)',
                            normal: {
                                opacity: 0,
                                label: {
                                    show: false,
                                    color: "#009cc9",
                                }
                            }
                        },
                    }],
                },
                series: [{
                    type: 'map',
                    roam: false,
                    label: {
                        normal: {
                            show: true,
                            textStyle: {
                                color: '#1DE9B6'
                            }
                        },
                        emphasis: {
                            textStyle: {
                                color: '#ffffff'
                            }
                        }
                    },

                    itemStyle: {
                        normal: {
                            borderColor: 'rgb(147, 235, 248)',
                            borderWidth: 1,
                            areaColor: {
                                type: 'radial',
                                x: 0.5,
                                y: 0.5,
                                r: 0.8,
                                colorStops: [{
                                    offset: 0,
                                    color: '#09132c' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#274d68' // 100% 处的颜色
                                }],
                                globalCoord: true // 缺省为 false
                            },
                        },
                        emphasis: {
                            areaColor: 'rgb(46,229,206)',
                            //    shadowColor: 'rgb(12,25,50)',
                            borderWidth: 0.1
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            if (params.data===undefined) {
                                return '';
                            }
                            var tipHtml = '';
                            tipHtml = '<div style="width:200px;height:120px;background:rgba(22,80,158,0.8);border:1px solid rgba(7,166,255,0.7)">'
                                +'<div style="width:100%;height:40px;line-height:40px;border-bottom:2px solid rgba(7,166,255,0.7);">'+'<i style="display:inline-block;width:8px;height:8px;background:#16d6ff;border-radius:40px;">'+'</i>'
                                +'<span style="margin-left:10px;color:#fff;font-size:16px;">'+(params.data.name||'')+'</span>'+'</div>'
                                +'<div style="padding:20px">'
                                +'<p style="color:#fff;font-size:12px;">'+'<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px">'+'</i>'
                                +'合同总数：'+'<span style="color:#11ee7d;margin:0 6px;">'+(params.data.contract_total_num||0)+'</span></p>'
                                +'<p style="color:#fff;font-size:12px;">'+'<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px">'+'</i>'
                                +'调解确认案件总数：'+'<span style="color:#11ee7d;margin:0 6px;">'+(params.data.tiaojie_total_num||0)+'</span></p>'
                                +'</div>'+'</div>';
                            // totalNum
                            // setTimeout(function() {
                            //     tooltipCharts(params.name);
                            // }, 10);
                            return tipHtml;
                        }
                    },
                    zoom: 1.1,
                    //     roam: false,
                    map: 'china', //使用
                    data: this.list
                },
                    {
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        data: effectScatterData,  // 使用新的数据结构
                        tooltip: {  // 新增专属tooltip配置
                            formatter: params => {
                                // return `${params.name}:  ${params.data.dataValue}`;
                                var tipHtml = '';
                                tipHtml = '<div style="width:200px;height:120px;background:rgba(22,80,158,0.8);border:1px solid rgba(7,166,255,0.7)">'
                                    +'<div style="width:100%;height:40px;line-height:40px;border-bottom:2px solid rgba(7,166,255,0.7);">'+'<i style="display:inline-block;width:8px;height:8px;background:#16d6ff;border-radius:40px;">'+'</i>'
                                    +'<span style="margin-left:10px;color:#fff;font-size:16px;">'+(params.data.name||'')+'</span>'+'</div>'
                                    +'<div style="padding:20px">'
                                    +'<p style="color:#fff;font-size:12px;">'+'<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px">'+'</i>'
                                    +'合同总数：'+'<span style="color:#11ee7d;margin:0 6px;">'+(params.data.contract_total_num||0)+'</span></p>'
                                    +'<p style="color:#fff;font-size:12px;">'+'<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px">'+'</i>'
                                    +'调解确认案件总数：'+'<span style="color:#11ee7d;margin:0 6px;">'+(params.data.tiaojie_total_num||0)+'</span></p>'
                                    +'</div>'+'</div>';
                                return tipHtml;
                            }
                        },
                        symbol: "circle",//散点图
                        symbolSize: 16,
                        showEffectOn: 'render',
                        rippleEffect: {
                            //涟漪特效
                            period: 15, //动画时间，值越小速度越快
                            brushType: "stroke", //波纹绘制方式 stroke, fill
                            scale: 4, //波纹圆环最大限制，值越大波纹越大
                        },
                        hoverAnimation: true,
                        label: {
                            show: false, //省份名显示隐藏
                            position: "right", //省份名显示位置
                            offset: [5, 0], //省份名偏移设置
                            formatter: function (params) {
                                //圆环显示省份名
                                return params.name;  //这个名字是根据data中的name来显示的
                            },
                            fontSize: 12,//文字大小
                        },
                        itemStyle: {
                            normal: {
                                color: '#DFB017'
                                /* function (value){ //随机颜色
                                 return "#"+("00000"+((Math.random()*16777215+0.5)>>0).toString(16)).slice(-6);
                                 }*/
                                ,
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        zlevel: 1
                    }]

            };
            //地图点击事件,根据点击某个省份计算出这个省份的数据
            myChart.on('click', (params) => {
                // console.log(params);

            });
            myChart.setOption(option);
        }
    },
    watch:{
        allData:{
            deep:true,
            immediate:true,
            handler(newVal){
                if(!newVal) return;

                if (newVal) {
                    this.$nextTick(() => {
                        this.list=newVal.sheng_list
                        this.chainaMap()
                    });
                }

            }
        }
    },
    mounted() {
        this.chainaMap()

    },
    created() {
    }
}

</script>

<style scoped lang="scss">
.china {
    height: 800px;
    width: 100%;
    z-index: 999;
    div{
        margin: 0px auto !important;
    }
}
.imgBox{
    z-index: -1;
    display: flex;
    justify-content: center;
    margin-left:80px;
    margin-top: -260px;
    animation: blink 5s infinite;
}
@keyframes blink {
    0% {
        opacity: 1; /* 动画开始时不透明 */
        transform: scale(1);
    }
    50% {
        opacity: 0.5; /* 动画中间时完全透明 */
        transform: scale(1.1);
    }
    100% {
        opacity: 1; /* 动画结束时重新不透明 */
        transform: scale(1);
    }
}
</style>